import useOrganizationsViewModel from './OrganizationsViewModel'

import CircleSpinner from '@components/shared/CircleSpinner'
import ConfirmationModal from '@components/shared/ConfirmationModal'
import CreateOrgWidget from './CreateOrgWidget'
import JoinOrgWidget from './JoinOrgWidget'
import OrganizationsTable from './OrganizationsTable'
import OrgJoinRequestsTable from './OrgJoinRequestsTable'
import SettingsWrapper from '../SettingsWrapper'

const Organizations = () => {
    
    const {
        loading,
        newOrgName,
        setNewOrgName,
        joinOrgName,
        setJoinOrgName,
        pendingDeleteOrg,
        setPendingDeleteOrg,
        pendingDeleteOrgJoinRequest,
        setPendingDeleteOrgJoinRequest,
        orgCounts,
        
        organizations,
        
        onCreateOrgClick,
        onJoinOrgClick,
        onConfirmDeleteClick,
        onConfirmDeleteJoinRequestClick,
        checkOrgExists,
    } = useOrganizationsViewModel()
    
    if (loading) return (
        <div className="Organizations card">
            <CircleSpinner className="flex justify-center w-full p-5 my-5" />
        </div>
    )
    
    return (
        
        <SettingsWrapper title="Organizations">
            
            <div className="flex gap-4">
                
                <CreateOrgWidget
                    newOrgName={newOrgName}
                    setNewOrgName={setNewOrgName}
                    checkOrgExists={checkOrgExists}
                    onCreateOrgClick={onCreateOrgClick} />
                
                <JoinOrgWidget
                    joinOrgName={joinOrgName}
                    setJoinOrgName={setJoinOrgName}
                    checkOrgExists={checkOrgExists}
                    onJoinOrgClick={onJoinOrgClick} />
            
            </div>
            
            <OrgJoinRequestsTable
                organizations={organizations}
                setPendingDeleteOrgJoinRequest={setPendingDeleteOrgJoinRequest} />
            
            <OrganizationsTable
                organizations={organizations}
                setPendingDeleteOrg={setPendingDeleteOrg} />
            
            <ConfirmationModal
                showModal={Boolean(pendingDeleteOrg)}
                showHideModal={setPendingDeleteOrg}
                title="Delete Organization"
                message={
                    <ul className="list-disc list-inside">
                            This affect: 
                        <li>
                            {pendingDeleteOrg?.members?.length} &nbsp;
                            {pendingDeleteOrg?.members?.length <= 1 ? 'user' : 'users'}
                        </li>
                        <li>
                            {orgCounts?.collections} {orgCounts?.collections <= 1 ? 'collection' : 'collections'}
                        </li>
                        <li>
                            {orgCounts?.runsheets} {orgCounts?.runsheets <= 1 ? 'runsheet' : 'runsheets'}
                        </li>
                            Are you sure you want to delete the organization?
                    </ul>
                }
                onConfirm={onConfirmDeleteClick}
                confirmButtonClass="btn-error" />
            
            <ConfirmationModal
                showModal={Boolean(pendingDeleteOrgJoinRequest)}
                showHideModal={setPendingDeleteOrgJoinRequest}
                title="Delete Organization Join Request"
                message={
                    <p>
                            Are you sure you want to delete the request from
                        {' '}
                        <b>{pendingDeleteOrgJoinRequest?.requester?.email}</b> to join the
                            organization &quot;{pendingDeleteOrgJoinRequest?.organization?.name}&quot;?
                    </p>
                }
                onConfirm={onConfirmDeleteJoinRequestClick} />
        
        </SettingsWrapper>
        
    )
    
}

export default Organizations
